import { Typography } from '@mui/material';

import { useStopwatchDuration } from './hooks/use-stopwatch-duration';

type Props = {
  originalTime: string;
};

export const StopwatchTimer = ({ originalTime }: Props) => {
  const duration = useStopwatchDuration(originalTime);

  if (!duration) return null;

  return (
    <Typography color="var(--brand02)">
      {duration.toFormat('hh:mm:ss')}
    </Typography>
  );
};
